<div class="form-group">
	<edit-organization 
        [(currClient)]="selectedClient" 
        [(facCount)]="facilityCount" 
        [(divCount)]="divisionCount" 
        [(jobCount)]="jobTitleCount" 
        [(deptCount)]="departmentCount" 
        [(showMinFields)]="showMinFields" 
        [(currentOrganization)]="selectedOrganization" 
        [(setStates)]="states"
        (isEdited)="onEdited($event)">
    </edit-organization>	
</div>